import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  ConfiguracionMargenGanancia,
  MargenGananciasState,
} from './interfaces/margenGanancias'

const initialState: MargenGananciasState = {
  configuraciones: [],
  loading: false,
  error: null,
}

const margenGananciasSlice = createSlice({
  name: 'margenGanancias',
  initialState,
  reducers: {
    setConfiguraciones: (
      state,
      action: PayloadAction<ConfiguracionMargenGanancia[]>,
    ) => {
      state.configuraciones = action.payload
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
})

export const { setConfiguraciones, setLoading, setError } =
  margenGananciasSlice.actions

export default margenGananciasSlice.reducer
